export const TagColors = {
  red: '!stroke-red-500 fill-red-500/20',
  orange: '!stroke-orange-500 fill-orange-500/20',
  green: '!stroke-green-500 fill-green-500/20',
  blue: '!stroke-blue-500 fill-blue-500/20',
  fuchsia: '!stroke-fuchsia-500 fill-fuchsia-500/20',
  teal: '!stroke-teal-500 fill-teal-500/20',
  pink: '!stroke-pink-500 fill-pink-500/20',
};
export const TagLabelColors = {
  red: '!bg-red-500',
  orange: '!bg-orange-500',
  green: '!bg-green-500',
  blue: '!bg-blue-500',
  fuchsia: '!bg-fuchsia-500',
  teal: '!bg-teal-500',
  pink: '!bg-pink-500',
};

/**
 * Enum for Initialization codes. Non-zero values indicate an error.
 * @readonly
 * @enum {number}
 */
export const INIT_ERRORS = {
  NONE: 0,
  NO_USER: 1,
  NO_KEYCHAIN: 2,
  COULD_NOT_CREATE_DEFAULT_FOLDER: 3,
};
